import {KeyValue} from "@angular/common";

export class AppConfig {
  constructor(init: Partial<AppConfig>) {
    Object.assign(this, init);
    this.Storage ??= localStorage;
    this.apiResponseCollapseEnabled = this.apiResponseCollapseEnabled ?? false;
  }

  name: string;
  apiResponseCollapseEnabled?: boolean = false;
  apiResponseLineCollapseLimit?: number = 10;
  Storage?: Storage;
  primeNgStateStorage?: 'local' | 'session' = 'local';
  Headers: KeyValue<string, string>[] = [];

  getStorage() {
    if (this.primeNgStateStorage == 'session'){
      return sessionStorage
    }
    return localStorage
  }
}
